'use strict';

// console.log('%crunning productDetail.js in app_belkin', 'color: green');
var processInclude = require('base/util');

$(document).ready(function () {
    // console.log('productDetail.js document ready.');
    processInclude(require('./components/video'));
    processInclude(require('./product/detail'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./product/estimatedShipping'));
    processInclude(require('./components/stickyPanel'));
});
